// extracted by mini-css-extract-plugin
var _1 = "overlay__INnih";
var _2 = "text__hV80v";
export { _1 as "overlay", _2 as "text" }
